import React from "react";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {withStyles} from "@material-ui/core/styles";

const materialStyles = {
  radio: {
    color: `inherit`,
    paddingRight: `5px`,
    paddingBottom: `8px`,
    paddingTop: `8px`
  },
  checked: {
    color: `inherit !important`
  },
  label: {
    fontSize: `17px`
  }
};

function RadioField(props) {
  const {input, label, classes} = props;
  return (
    <FormControlLabel
      control={
        <Radio
          {...input}
          classes={{colorSecondary: classes.radio, checked: classes.checked}}
        />
      }
      label={label}
      labelPlacement="end"
      classes={{label: classes.label}}
    />
  );
}

RadioField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(materialStyles)(RadioField);
